import { render } from "./LayoutFull.vue?vue&type=template&id=3b8d70f6"
import script from "./LayoutFull.vue?vue&type=script&lang=js"
export * from "./LayoutFull.vue?vue&type=script&lang=js"
script.render = render

export default script